function getPerformancePaintTimings() {
    return new Promise((resolve, reject) => {
        window.addEventListener('load', () => {
            const performance = window.performance;
            if (performance && performance.getEntriesByType('paint').length > 0) {
                resolve(performance.getEntriesByType('paint'));
            } else {
                reject(new Error('Performance metrics are not defined'));
            }
        });
    });
}

export { getPerformancePaintTimings };
